var exports = {
  "bR": "action-bar-position__R-fRYb",
  "Vq": "left-action-bar__aT-vYz",
  "Bp": "left-action-bar-draft-compact__QkuPK8",
  "Ph": "left-action-bar-draft-relaxed__JLN5sy",
  "wA": "left-action-bar-new__AcllvV",
  "XR": "addCommentButtonNew__g9fStB",
  "Jj": "actionBarArrowSizing__9wMxBt",
  "hV": "actionBarHeight__WPvcvM",
  "LE": "actionBarStartCommentWidth__3uxaZO",
  "i": "action-bar-button-group__8LnRIV",
  "wO": "action-bar-button-group--no-leading__T1Ohls",
};

module.exports = exports;
